import firebase from 'firebase/app';
import 'firebase/messaging';

export const initializeFirebase = () => {
  if (isIosWebView()) {
    console.log("iOS WebView wykryty – pomijam inicjalizację FCM");
    return;
  }

  const firebaseConfig = {
    apiKey: "AIzaSyDKZmg1CoaErChdjgNtKDBxdUL_3SjNGzY",
    authDomain: "trackerpinguinobe.firebaseapp.com",
    projectId: "trackerpinguinobe",
    storageBucket: "trackerpinguinobe.firebasestorage.app",
    messagingSenderId: "1062239162611",
    appId: "1:1062239162611:web:30a60db05fa6e2773f6786",
    measurementId: "G-VPJBWFG203"
  };

  firebase.initializeApp(firebaseConfig);

  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then((registration) => {
      firebase.messaging().useServiceWorker(registration);
      console.log("Service Worker zarejestrowany");
    })
    .catch(err => {
      console.error("Błąd rejestracji Service Workera:", err);
    });
};

function isIosWebView() {
  const ua = navigator.userAgent;
  return /iPhone|iPad|iPod/i.test(ua);
}

export const askForPermissionToReceiveNotifications = async () => {
  try {
    if (isIosWebView()) {
      const tokenIOS = window.localStorage.getItem('token') ?? '';
      return tokenIOS !== ''
        ? { status: "SUCCESS", token: tokenIOS }
        : { status: "FAIL", error: 'Notification permission denied' };
    } else {
      const messaging = firebase.messaging();
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        const token = await messaging.getToken({
          vapidKey: "BHseoIpZt1_p0GWZZWW9Ydqo6bx_snZPTLETk9iv3uZ7XH2RJqnq0J8hukPDnMzSm7_ZgKpNT_TOXaGd7Wp3eQQ"
        });
        return token
          ? { status: "SUCCESS", token }
          : { status: "FAIL", error: 'Token is null' };
      } else {
        return { status: "FAIL", error: 'Notification permission denied' };
      }
    }
  } catch (error) {
    console.error("Błąd przy pobieraniu tokenu:", error);
    return { status: "FAIL", error };
  }
};
